import React from "react";
import "./ToTop.scss";

import ArrowTopSVG from "../../assets/icons/arrowTop.svg";

const ToTop = () => {
	const scrollTop = () => window?.scrollTo({ top: 0, behavior: `smooth` });

	return (
		<button onClick={scrollTop} className="totop-btn">
			<ArrowTopSVG />
		</button>
	);
};

export default ToTop;
